export const tyrePosList = [
  "L01", "L02", "L03", "L04", "L05", "L06"
  , "R01", "R02", "R03", "R04", "R05", "R06"
]